'use client';

import React from 'react';

interface ClientsKpiStripProps {
  totalClients: number;
  newIn30Days: number;
  neverCame: number;
  activeCount: number;
  inactiveCount: number;
}

export default function ClientsKpiStrip({
  totalClients,
  newIn30Days,
  neverCame,
  activeCount,
  inactiveCount
}: ClientsKpiStripProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3.5">
      {/* 1. Clientes */}
      <div className="bg-white border border-slate-200/90 rounded-2xl p-4 shadow-sm hover:shadow-md transition">
        <div className="text-xs font-bold text-slate-700">
          Clientes
        </div>
        <div className="text-2xl md:text-3xl font-extrabold text-slate-900 mt-2">
          {totalClients}
        </div>
        <div className="text-[11px] text-slate-400 mt-1 font-medium">
          {newIn30Days} nuevas en 30 días
        </div>
      </div>

      {/* 2. Nunca vinieron */}
      <div className="bg-white border border-slate-200/90 rounded-2xl p-4 shadow-sm hover:shadow-md transition">
        <div className="text-xs font-bold text-slate-700">
          Nunca vinieron
        </div>
        <div className="text-2xl md:text-3xl font-extrabold text-slate-900 mt-2">
          {neverCame}
        </div>
        <div className="text-[11px] text-slate-400 mt-1 font-medium">
          sin ninguna visita
        </div>
      </div>

      {/* 3. Activas */}
      <div className="bg-white border border-slate-200/90 rounded-2xl p-4 shadow-sm hover:shadow-md transition">
        <div className="text-xs font-bold text-[#047857]">
          Activas
        </div>
        <div className="text-2xl md:text-3xl font-extrabold text-slate-900 mt-2">
          {activeCount}
        </div>
        <div className="text-[11px] text-slate-400 mt-1 font-medium">
          vinieron en los últimos 90 días
        </div>
      </div>

      {/* 4. Inactivas */}
      <div className="bg-white border border-slate-200/90 rounded-2xl p-4 shadow-sm hover:shadow-md transition">
        <div className="text-xs font-bold text-slate-700">
          Inactivas
        </div>
        <div className="text-2xl md:text-3xl font-extrabold text-slate-900 mt-2">
          {inactiveCount}
        </div>
        <div className="text-[11px] text-slate-400 mt-1 font-medium">
          sin visitas hace 90+ días
        </div>
      </div>
    </div>
  );
}
